/**
 * Shared permissions module
 *
 * Role-based permission system for Orientamos Hub.
 */

export const USER_ROLES = ['user', 'superadmin'] as const

export type UserRole = (typeof USER_ROLES)[number]

export type PermissionAction =
  | 'contract:delete:any-status'
  | 'contract:edit:any-status'
  | 'intake:delete:any-status'

export const ROLE_PERMISSIONS: Record<PermissionAction, readonly UserRole[]> = {
  'contract:delete:any-status': ['superadmin'],
  'contract:edit:any-status': ['superadmin'],
  'intake:delete:any-status': ['superadmin'],
}

/**
 * Check if a role has permission to perform an action
 */
export function hasPermission(role: UserRole, action: PermissionAction): boolean {
  return ROLE_PERMISSIONS[action].includes(role)
}

/**
 * Safely extract a UserRole from Clerk publicMetadata.
 * Defaults to 'user' if the metadata is missing or invalid.
 */
export function resolveRole(metadata: unknown): UserRole {
  if (
    typeof metadata === 'object' &&
    metadata !== null &&
    'role' in metadata &&
    typeof (metadata as Record<string, unknown>).role === 'string' &&
    USER_ROLES.includes((metadata as Record<string, unknown>).role as UserRole)
  ) {
    return (metadata as Record<string, unknown>).role as UserRole
  }
  return 'user'
}
